import { http } from '@/api/http';
import type { OperationResult, Schemas } from '@/api/shared';

export const medicalHistoryApi = {
  /** GET /persons/{guid}/medical-history — medical & developmental history text. */
  getMedicalHistory: (
    guid: string,
    options?: { signal?: AbortSignal },
  ): Promise<OperationResult<'getMedicalHistory'>> =>
    http.get<OperationResult<'getMedicalHistory'>>(
      `/persons/${encodeURIComponent(guid)}/medical-history`,
      options,
    ),

  /** PUT /persons/{guid}/medical-history — update narrative text (full replace). */
  updateMedicalHistory: (
    guid: string,
    body: Schemas['MedicalHistory'],
    options?: { signal?: AbortSignal },
  ): Promise<Schemas['MedicalHistory']> =>
    http.put<Schemas['MedicalHistory']>(
      `/persons/${encodeURIComponent(guid)}/medical-history`,
      body,
      options,
    ),

  /** DELETE /persons/{guid}/medical-history — clear narrative (204). */
  clearMedicalHistory: (
    guid: string,
    options?: { signal?: AbortSignal },
  ): Promise<undefined> =>
    http.delete<undefined>(
      `/persons/${encodeURIComponent(guid)}/medical-history`,
      options,
    ),
};
